import { Italic as ItalicToExtend } from '@tiptap/extension-italic';

export const Italic = ItalicToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: {
                default: null
            }
        }
    }
})
